import React from "react";
import "./styles.scss";
import classnames from "classnames";

interface FellouButtonProps {
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  className?: string;
  mode?:
  | "white-blackbg"
  | "blue-blackbg"
  | "black-blackbg"
  | "white-whitebg"
  | "blue-whitebg"
  | "black-whitebg" // 黑字白底
  | "grey-greyb-blackbg" // 灰字灰色框黑低
  | "dominant-color"
  | "dominant-color-big"
  | "white-bg-purple-link"
  | "white-border-transparent-bg"
  | "disable-bg-btn"
  | "white-graybg"

  style?: React.CSSProperties;
  size?: string; // 可以定义为特定字符串字面量类型
  arrow?: boolean; // 有无箭头, 可自定义
  type?: "button" | "text"; // 类型 button, text
  transparent?: boolean;
  light?: boolean;
}

export const FellouButton: React.FC<FellouButtonProps> = ({
  children,
  onClick,
  className,
  mode,
  style,
  size,
  arrow,
  type,
  transparent,
  light,
}) => {
  const cls = classnames({
    "fellou-button-new3": true,
    [className!]: !!className,
    [size!]: size,
    [type!]: type,
    ["btn-" + mode!]: mode,
    ["transparent"]: transparent,
    ["light"]: light,
  });

  return (
    <div className={cls} onClick={onClick} style={style}>
      {children}
      {arrow && (
        <div className="box-i">
          <i className={"iconfont steamory-arrow-right-line"}></i>
        </div>
      )}
    </div>
  );
};
